export default __webpack_public_path__ + "static/media/MilhouseVanHouten.4656f3e8.png";